exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".msgPush{min-height:calc(100vh - 60px)}.msgPush .el-input,.msgPush .el-select{display:inline-block}.msgPush .el-input{width:auto}.msgPush .el-button{display:inline-block}.msgPush .el-button+.el-button{margin-left:0}.msgPush .search{margin-left:30px;margin-bottom:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-ccf55c0a!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/secretary/message/msgPush.vue
// module id = 631
// module chunks = 0